import React from 'react';
import './App.css';
import Game from './Game';

export default function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}
